/**
 * Scan all modals in the DOM, move them to the DOM top level and attach some code to them
 *
 * In order to create a Modal, you need to have DOM element with a "data-modal-for" attribute  which will references the id of the modal div.
 *
 * Example :
 *  <button data-modal-for="modal-id"></button>
 *  <div id="modal-id" class="modal"></div>
 */

export default function initModal(selector = "") {

    $(function () {

        // Move every modal in top level of the DOM to avoid z-index issue
        $(`${selector} .modal`).each(function (i, modal) {
            $(modal).appendTo(document.body);
        });

        // Show/hide logic
        $(`${selector} [data-modal-for]`).each(function (i, e) {

            function showModal(modal) {
                modal.addClass("modal--show");
                $("html").css("position", "absolute");
                $("html").css("left", "0");
                $("html").css("right", "0");
                $("html").css("margin", "auto");
                return false;
            }

            function hideModal(modal) {
                modal.removeClass("modal--show");
                $("html").css("position", "");
                $("html").css("left", "");
                $("html").css("right", "");
                $("html").css("margin", "");
                return false;
            }

            let modalId = $(e).attr("data-modal-for");
            let modal = $(`#${modalId}`); // Find modal according to "data-modal-for" attribute
            let modalBg = $(modal).find(".modal__bg");
            let closeButton = (modal).find(".modal__inner__header__close");

            // Open modal handlers
            $(e).click(showModal.bind(this, modal));

            // Close modal handlers
            modalBg.click(hideModal.bind(this, modal));
            closeButton.click(hideModal.bind(this, modal));

            document.addEventListener("keydown", function (keyEvent) {
                if (keyEvent.which === 27) { // Pressing "Escape" key
                    hideModal(modal);
                }
            });
        });
    });
}

window.initModal = initModal;



// WEBPACK FOOTER //
// ./js/modal/Modal.js